var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items)?_c('div',{staticClass:"meta-block-wrapper",class:_vm.theme},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"block-item"},[(item.icon)?_c('base-svg',{attrs:{"svg":item.icon,"height":"35px"}}):_vm._e(),_c('span',{domProps:{"innerHTML":_vm._s(item.content)}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }